<div class="mb-4 mb-lg-5">
  <h1 class="mb-1" [innerHTML]="'termsOfUse.title' | translate | safeHtml"></h1>
  <p>{{ 'termsOfUse.subTitle' | translate }}</p>
</div>
